import { memo, PropsWithChildren, ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MerchantPaymentMethodsFilters from "./MerchantPaymentMethodsFilters";
import { USE_PAYMENT_METHODS_V2 } from "../paymentMethodsUi";

const MerchantPaymentMethodsFiltersPanel = ({ children, bulkControl }: PropsWithChildren<{ bulkControl?: ReactNode }>) => {
    const filtersSx = {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap'
    };

    if (!USE_PAYMENT_METHODS_V2) return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
            <Box sx={filtersSx}>
                <MerchantPaymentMethodsFilters sx={filtersSx} />
                {bulkControl}
            </Box>
            {children}
        </Box>
    );

    return (
        <Box sx={{ display: 'grid', gap: 1.5, mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 2 }}>
                <Box>
                    <Typography variant='subtitle2' color='text.secondary' sx={{ mb: 0.75 }}>
                        Filter payment methods
                    </Typography>
                    <MerchantPaymentMethodsFilters sx={filtersSx} />
                </Box>
                {children}
            </Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                minHeight: 58,
                px: 2,
                py: 1,
                borderRadius: 1,
                bgcolor: 'action.hover',
                border: 1,
                borderColor: 'divider'
            }}>
                <Typography variant='subtitle2' sx={{ mr: 2, whiteSpace: 'nowrap' }}>Bulk edit</Typography>
                {bulkControl}
            </Box>
        </Box>
    );
};

export default memo(MerchantPaymentMethodsFiltersPanel);
